import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    body: {
        fontFamily: "\"Helvetica Neue\",Helvetica,Arial,sans-serif",
    },
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 550,
    },
    cell: {
        fontSize: 14,
    }
});
